import useSWR from 'swr'
import { fetchFamilyStock } from '@api/backendCatalog/fetchFamilyStock'
import trackError from '@helpers/trackError'
import { BackendStockKey } from 'types/backendPdp'

// The colourway's launch_date off the backend's live stock response, or null
// — while it loads, when the request fails or 404s, when the handle has no
// backend colourway, or when it has no date. Null always means "behave as
// today", so the page never waits on this or shows Coming Soon before the
// date has actually arrived. One request per family, cached by SWR, so
// switching colour within a family doesn't refetch.
export default function useColourwayLaunchDate(
  stockKey: BackendStockKey | undefined
): string | null {
  const familySlug = stockKey?.familySlug

  const { data: stock } = useSWR(
    familySlug ? ['backend-family-stock', familySlug] : null,
    () => fetchFamilyStock(familySlug as string),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      onError: error => {
        trackError(new Error('Failed to fetch backend family stock'), {
          error: error as Error,
          section: 'PDP',
          familySlug
        })
      }
    }
  )

  if (!stock || !stockKey) return null

  return stock[stockKey.handle]?.launch_date ?? null
}
